export const navigatorLang = {
    "zh-CN": "zh-cn",
    "zh-TW": "zh-tw",
    "zh-HK": "zh-hk",
    "en-US": "en-us",
    "en": "en-us",
    "en-GB": "en-gb",
    "en-CA": "en-ca",
    "en-IN": "en-in",
    "en-MY": "en-my",
    "en-NZ": "en-nz",
    "en-AU": "en-au",
    "ko-KR": "ko-kr",
    "ja-JP": "ja-jp",
    "fr": "fr-fr",
    "fr-BE": "fr-fr",
    "fr-CA": "fr-fr",
    "fr-LU": "fr-fr",
    "th": "th-th",
    "es": "es-es",
    "es-AR": "es-es",
    "es-GT": "es-es",
    "es-BO": "es-es",
    "es-HN": "es-es",
    "es-CL": "es-es",
    "es-MX": "es-es",
    "es-CO": "es-es",
    "es-PA": "es-es",
    "es-CR": "es-es",
    "es-PE": "es-es",
    "es-DO": "es-es",
    "es-PR": "es-es",
    "es-EC": "es-es",
    "es-PY": "es-es",
    "es-SV": "es-es",
    "es-GQ": "es-es",
    "es-UY": "es-es",
    "es-ES": "es-es",
    "es-VE": "es-es",
    "es-NI": "es-es",
    "ru": "ru-ru",
    "ru-MIY": "ru-ru",
    "ru-mo": "ru-ru",
    "po": "po-pt",
    "pt-BR": "po-pt",
    "pt-PT": "pt-pt",
    "de": "de-de",
    "de-AT": "de-at",
    "de-CH": "de-ch",
    "it": "it-it",
    "it-CH": "it-it",
    "vi": "vi-vi",
    "el": "gr-el",
    "ar-SA": "ar-ar",
    "ar-IQ": "ar-ar",
    "nl": "ho-nl",
    "nl-BE": "ho-nl",
    "nl-NL": "ho-nl",
    "sv": "sw-sv",
    "sv-FI": "sw-sv",
    "pl": "po-pl",
    "pl-PL": "po-pl",
    "id": "in-id",
    "ro": "ro-ro",
    "ro-MO": "ro-ro",
    "hu": "hu-hu",
    "da": "de-da"
};

export function switchLang(lang) {
    let locale = localStorage.getItem("tci18nLocale") || navigatorLang[navigator.language] || "zh-cn";
    if (locale === lang) {
        return;
    }
    localStorage.setItem("tci18nLocale", lang);

    setTimeout(function () {
        globalThis.location.reload();
    }, 100);
}
